// Rango garantizado para requests de indicadores backend-fed.
//
// Contrato: el rango de la petición debe cubrir al menos el warmup del
// indicador + 20% de margen. Si el chart ya tiene más velas cargadas,
// se respeta ese rango (no se reduce).
//
// Semántica de null: devuelve null cuando no puede calcular un rango
// válido (candleData vacío, última vela sin time, o timeframe sin
// segundos conocidos). El llamante debe interpretar null como "no
// disparar request ni limpiar datos existentes".
//
// Uso:
//   const range = ensureIndicatorRange(candleData, timeframe, 60)
//   if (range === null) return // guard: sin basura al backend
//   const from_time = range.from_time
//   const to_time = range.to_time

import { tfSeconds } from './mtf.js'
import { toUtcSeconds } from './utcTime.js'

// Warmup mínimo (en velas del TF del chart) por indicador backend-fed.
// Valores alineados con el backend: SmartMoneyStrategyEngine usa
// warmup_bars = max(swing_len * 3, 50) ≈ 50 velas; se redondea a 60 para
// cubrir el peor caso con margen.
export const INDICATOR_WARMUP_BARS = {
  ict_quantum: 60,
  choch_bos_quantum: 60,
}

export function ensureIndicatorRange(candleData, timeframe, warmupBars) {
  const tfSec = tfSeconds(timeframe)
  if (!tfSec || tfSec <= 0) return null
  if (!Array.isArray(candleData) || candleData.length === 0) return null

  const lastCandle = candleData[candleData.length - 1]
  const lastSec = toUtcSeconds(lastCandle?.time)
  if (lastSec == null || !Number.isFinite(lastSec) || lastSec <= 0) return null

  const chartBars = candleData.length
  const minBars = Math.max(chartBars, Math.ceil(warmupBars * 1.2))
  const neededSec = minBars * tfSec
  const fromTime = lastSec - neededSec

  if (fromTime < 0) return null

  return {
    from_time: fromTime,
    to_time: lastSec,
  }
}
